<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="项目名称">
        <el-input v-model="form.projectName" disabled ></el-input>
      </el-form-item>
      <el-form-item label="目录名称">
        <el-input v-model="form.menuName" disabled></el-input>
      </el-form-item>
      <el-form-item label="文件标题" prop="title">
        <el-input v-model="form.title" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="文件说明" prop="content">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          v-model="form.content"
          maxlength="400"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传">
        <VUpload
          :fileList.sync="attachList"
          :limit="1"
          :max="256 * 1024 * 1024"
          :disabled="mode == 'edit'"
        />
      </el-form-item>
      <el-form-item label="浏览权限" prop="accessPermission">
        <el-select v-model="form.accessPermission" placeholder="请选择">
          <el-option
            v-for="item in permissionOptions"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下载权限">
        <el-radio v-model="form.downloadFlag" :label="1" size="small">允许下载</el-radio>
        <el-radio v-model="form.downloadFlag" :label="0" size="small">不允许下载</el-radio>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ submitTitle }}</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import VUpload from '@/views/components/v-upload-knowledge';

import {
  saveKnowledgeProject,
  getKnowledgeProjectSelectById,
  updateKnowledgeProject,
  getDictionary,
} from '@/api/crmedical/knowledge/project';

export default {
  components: { VUpload },
  props: ['form', 'mode'],
  data() {
    return {
      groupName: '华润医疗集团文件',
      attachList: [],
      checkList: [],
      dialogShow: false,
      choosenProjects: [],
      radio: 1,
      throttle: false,
      submitTitle: '确定',
      permissionOptions: [],
      rules: {
        title: [
          { required: true, message: '请输入标题' },
          { min: 1, max: 100, message: '长度在 1 到 50 个字符' },
        ],
        content: [
          { required: true, message: '请输入说明' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符' },
        ],
        accessPermission: [{ required: true, message: '请选择浏览权限' }],
      },
    };
  },
  mounted() {
    console.log('this.mode==>', this.mode);
    if (this.mode == 'edit') {
      getKnowledgeProjectSelectById({ id: this.form.id }).then((res) => {
        if (res.data.link) {
          this.attachList = [{ link: res.data.link, originalName: res.data.link }];
          this.form.attachIds = res.data.attachIds;
        }
      });
    }
  },
  created() {
    // getDictionary({code:'knowledge_project_file_access_permission'}).then(res=>{
    //   console.log('res knowledge_project_file_access_permission==>',res);
    //   this.permissionOptions = res.data
    // })
    this.permissionOptions = [
      {dictKey:1,dictValue:'全部可见'},
      {dictKey:2,dictValue:'个人可见'},
      {dictKey:3,dictValue:'所在机构可见'},
    ]
  },
  methods: {
    handleChooseProject() {
      this.dialogShow = true;
    },
    onSubmit() {
      this.$refs.form.validate((v) => {
        if (!v) return;
        if (this.attachList.length == 0) {
          this.$message.warning('请上传一个文件');
          return;
        }
        if (this.throttle) return;
        this.throttle = true;
        if (this.mode == 'edit') {
          const postData = {
            id: this.form.id,
            content: this.form.content,
            title: this.form.title,
            accessPermission: this.form.accessPermission,
            projectIds: this.form.projectIds,
            downloadFlag: this.form.downloadFlag,
            menuId: this.form.menuId,
            attachIds: this.form.attachIds,
          };
          console.log('postData==>', postData);
          updateKnowledgeProject(postData)
            .then((res) => {
              this.throttle = false;
              this.$message.success(res.msg);
              this.$emit('close');
            })
            .catch(() => {
              this.throttle = false;
              this.$emit('close');
            });
        } else {
          this.form.attachIds = this.attachList.map((ele) => ele.id).toString();
          saveKnowledgeProject(this.form)
            .then((res) => {
              this.throttle = false;
              this.$message.success(res.msg);
              this.$emit('close');
            })
            .catch(() => {
              this.throttle = false;
              this.$emit('close');
            });
        }
      });
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>